export default {
  header: 'Create one-time part',
  subHeader: 'Create a one-time part to use for your quality report',
};
